import { jsx as _jsx } from "react/jsx-runtime";
import { DeviceStatusListItem } from './device-status-list-item';
import NOB from '../../../../constants/language-strings';
import { ListItem } from '../../../../components/ListItem/list-item';
import { Skeleton } from '@purpurds/purpur/skeleton';
import styled from 'styled-components';
import spacing from 'theme/spacing';
import { InfoBox } from 'components/InfoBox/info-box';
const StyledSkeleton = styled(Skeleton) `
  width: 100%;
  height: 5rem;
  margin-top: ${spacing.spacing4};
`;
export const DeviceStatusList = ({ devices, isFetching, toggleDisplaySam, error, }) => {
    if (isFetching)
        return _jsx(StyledSkeleton, {});
    if (error || devices.length === 0)
        return (_jsx(InfoBox, { firstInfoBoxLine: NOB.HEALTH_CHECK.DEVICE_STATUS_ERROR }));
    return (_jsx("div", { children: devices.map(device => (_jsx(ListItem, { onClick: () => toggleDisplaySam(device), clickable: device.pollable, isFullyRounded: true, children: _jsx(DeviceStatusListItem, Object.assign({}, device)) }, device.description))) }));
};
